import { requester } from '../utils';

export const fetchAllPayments = query => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/payment?${query}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const fetchPaymentDetails = id => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/payment/${id}`,
        method: 'GET',
        withAuth: true
      })
      .then(result => {
        resolve(result.payload);
      })
      .catch(err => {
        console.log('fetch users error', err);
        reject(err);
      });
  });
};

export const getPaymentsExcelFile = query => {
  return new Promise((resolve, reject) => {
    requester
      .getFileFromAPI({
        route: 'v1/payment/excel?' + query,
        contentType: 'application/octet-stream'
      })
      .then(res => {
        var filename = decodeURI(res.headers['content-disposition'].split('filename=')[1]);
        var blob = new Blob([res.data], { type: 'application/octet-stream' });
        resolve({ filename, blob });
      })
      .catch(err => {
        reject(err);
      });
  });
};
